import { HttpErrorResponse } from '@angular/common/http';
import {
    Component, OnInit
} from '@angular/core';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { HttpService } from '../../services/http.service';
import IDropdown from '@crediblefinance/credible-ui/lib/interfaces/IDropdown';
import { AmbassadorService } from '../../services/ambassador.service';

@Component({
    selector: 'app-my-moon-history',
    templateUrl: './my-moon-history.component.html',
    styleUrls: [ './my-moon-history.component.scss' ]
})

export class MyMoonHistoryComponent implements OnInit {
    loading: boolean = false;
    moons: Array<any> = [];
    loading_stats = true;
    stats: any = {};
    total_count: number = 0;
    page: number = 0;
    limit: number = 10;
    opened_panel: string = '';
    reward_type_options: Array<IDropdown> = [{
        label: 'All',
        value: '',
        optionEnabled: true
    },
    {
        label: 'Referrals',
        value: 'referrals',
        optionEnabled: true
    },
    {
        label: 'Tasks',
        value: 'tasks',
        optionEnabled: true
    }];
    reward_type: string = this.reward_type_options[0].value;

    constructor(public httpService: HttpService, 
        private cfAlertService: CfAlertService, 
        private ambassadorService: AmbassadorService
    ) { }

    ngOnInit(): void {
        console.log('my-moon-history.component.ts ngOnInit()');

        this.getMoonsCreditHistory();
        this.getMoonCreditStats();

        this.httpService.setMetaData('My Moons', 'Moons of the user');
    }

    afterExpand(credit_id: string) {
        this.opened_panel = credit_id;

        console.log('afterExpand', credit_id);
    }

    afterCollapse(credit_id: string) {
        console.log('afterCollapse', credit_id);
    }

    getMoonsCreditHistory() {
        this.loading = true;

        this.ambassadorService.getMoonsCreditHistory(this.reward_type, this.page, this.limit).subscribe((res: any) => {
            this.moons = res.data;
            this.total_count = res.total_count;

            if (this.moons.length > 0)
                this.opened_panel = this.moons[0].credit_id;

            this.loading = false;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.loading = false;

            this.cfAlertService.showError(err);
        });
    }

    pageChanged(event: any) {
        this.page = event;
        this.getMoonsCreditHistory();
    }

    changeRewardType(options: IDropdown) {
        this.reward_type = options.value;
        this.page = 0;
        this.getMoonsCreditHistory();
    }

    getStatusClasses() {
        const classes: any = {
            'status-success': true
        };

        return classes;
    }

    getMoonCreditStats() {
        this.loading_stats = true;

        this.ambassadorService.getMoonCreditStats().subscribe((res) => {
            this.stats = res.data;
            this.loading_stats = false;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.loading_stats = false;

            this.cfAlertService.showError(err);
        });
    }
}

